/*
 * Copyright (c) 2023. Haodong JU
 */

import IKDataEntity from '@/plugins/EntityFrameWork/IKDataEntity'
import { hillo } from 'hillo'
import DishStatistics from '@/model/dataLayer/api/statistic/DishStatistics'
import OperationLog from '@/model/dataLayer/api/operationLog/OperationLog'
import { groupBy, sumBy } from 'lodash'
import i18n from '@/i18n'

const entity = {
  _action: {},
  total: {
    displayName: 'TotalOf'
  },
  percent: {}
}

const config = {
  load: async function (filter) {
    const dateFilter = [
      filter[0]?.dateFilter[0],
      filter[0]?.dateFilter[1]
    ]
    const Operation = {
      PrintMalatang: 'PrintMalatang',
      ClearCart: 'ClearCart',
      ChangeMalatang: 'ChangeMalatang',
      HangOrder: 'HangOrder',
      Sales: 'Sales'
    }
    const keys = Object.keys(Operation)
    const dishStatistics = (await DishStatistics.getList(true, { dateFilter })).filter(
      it => it.code.substr(0, 2) === 'ea' && it.name.includes('-'))
    const operationLogGroup = groupBy(await OperationLog.getList(true, { dateFilter }), 'action')
    const arr = keys.map(it => {
      if (it === Operation.Sales) {
        return {
          _action: it,
          total: sumBy(dishStatistics, (b) => {
            return parseFloat(b.totalCount)
          })
        }
      } else {
        return {
          _action: it,
          total: sumBy(operationLogGroup[it], (x) => {
            return parseFloat(x.extraId)
          })
        }
      }
    }
    )
    const totalNumberWithOutPrint = sumBy(arr.filter(it => it._action !== Operation.PrintMalatang), 'total')
    arr.forEach(it => {
      if (it._action !== Operation.PrintMalatang) {
        it.percent = ((it.total / totalNumberWithOutPrint) * 100)
          ? ((it.total / totalNumberWithOutPrint) * 100).toFixed(
              2) + '%'
          : 0
      } else {
        it.percent = i18n.t('DoesNotToBeCalculated')
      }
    })
    return arr
  },

  edit: function (item) {
    return hillo.post('AccessLog.php?op=editOperationLogNote', {
      ...item
    })
  }
}

export default IKDataEntity.ModelFactory(entity, config)
